import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "undefined") {
      try {
        // Track page views automatically
        window.gtag("config", "AW-17334762760", {
          page_path: location.pathname,
        });

        // Send a page view event
        window.gtag("event", "page_view", {
          page_path: location.pathname,
          page_title: document.title,
        });
      } catch (error) {
        console.error("Error sending page view to Google Ads:", error);
      }
    }
  }, [location]);
};
